import { useState, useEffect } from "react";

// ---------- Simple Custom Toast ----------
const Toast = ({ message, type }) => (
  <div
    className={`fixed top-4 right-4 px-4 py-2 rounded-md shadow-md text-white z-[9999]
      ${type === "success" ? "bg-green-600" : "bg-red-600"}`}
  >
    {message}
  </div>
);

const ExtendTimePopup = ({ rfq, onClose, refresh }) => {
  const [minutes, setMinutes] = useState('');
  const [mode, setMode] = useState("");
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);

  useEffect(() => {
    if (!rfq) return;

    if (rfq.status === "Order Confirmed") {
      setMode("blocked");
    } else if (rfq.status === "Waiting For Supplier Responses") {
      setMode("extend_suppliers");
    } else if (rfq.status === "Waiting For Payment") {
      setMode("extend_payment");
    } else {
      setMode("reactivate"); // expired or cancelled
    }
  }, [rfq]);

  const showToast = (msg, type = "success") => {
    setToast({ message: msg, type });
    setTimeout(() => setToast(null), 2500);
  };

  const submit = async () => {
    if (loading) return;
    setLoading(true);

    try {
      if (mode === "extend_suppliers") {
        await handleRfqWaitingTime();
      } else if (mode === "extend_payment") {
        await handlePaymentWaitingTime();
      } else if (mode === "reactivate") {
        await handleRfqWaitingTime(true);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleMinutesChange = (e) => {
  // Allow only digits
  const cleaned = e.target.value.replace(/[^0-9]/g, "");

  setMinutes(cleaned);
};

/* const handleMinutesChange = (e) => {
  // Keep only digits
  let cleaned = e.target.value.replace(/[^0-9]/g, "");

  // Limit to max 3 digits
  if (cleaned.length > 3) {
    cleaned = cleaned.slice(0, 3);
  }

  setMinutes(cleaned);
}; */

  // ---------------- RFQ Waiting Time Handler ----------------
  const handleRfqWaitingTime = async (reactivate = false) => {
    if (!rfq?._id) {
      showToast("Invalid RFQ ID", "error");
      return;
    }

    const token = sessionStorage.getItem("token");

    const res = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/rfq/extend-RFQ-waiting-time`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-token": token
        },
        body: JSON.stringify({
          rfq_id: rfq._id,
          extend_minutes: minutes,
          reactivate
        }),
      }
    );

    const data = await res.json();
    if (data.success) {
      showToast("Supplier Response Time Extended Successfully");
      refresh();
      onClose();
    } else {
      showToast(data.message || "Failed to extend time", "error");
    }
  };

  // ---------------- Payment Waiting Time Handler ----------------
  const handlePaymentWaitingTime = async () => {
    if (!rfq?._id) {
      showToast("rfq not found", "error");
      return;
    }

    const token = sessionStorage.getItem("token");

    const res = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/rfq/extend-payment-processing-time`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-token": token
        },
        body: JSON.stringify({
          rfq_id: rfq._id,
          extend_minutes: minutes,
        }),
      }
    );

    const data = await res.json();
    if (data.success) {
      showToast("Payment Waiting Time Extended Successfully");
      refresh();
      onClose();
    } else {
      showToast(data.message || "Failed to extend time", "error");
    }
  };

  // ----------- Title & Description UI ----------------
  const getTitle = () => {
    switch (mode) {
      case "blocked": return "Extension Not Allowed";
      case "extend_suppliers": return "Extend Supplier Response Time";
      case "extend_payment": return "Extend Payment Processing Time";
      case "reactivate": return "Reactivate RFQ Timer";
      default: return "Extend Time";
    }
  };

  const getDescription = () => {
    switch (mode) {
      case "blocked":
        return "This RFQ is already awarded. You cannot extend the waiting time.";
      case "extend_suppliers":
        return "Add extra minutes for suppliers to submit their responses.";
      case "extend_payment":
        return "Add extra waiting time for customer payment.";
      case "reactivate":
        return "The RFQ has expired. You can restart the timer by adding new minutes.";
      default:
        return "";
    }
  };

  return (
    <>
      {toast && <Toast message={toast.message} type={toast.type} />}

      <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-[999]">
        <div className="bg-white p-5 rounded-xl w-80 shadow-xl border border-gray-200">

          <h3 className="font-bold text-lg text-gray-800 mb-2">{getTitle()}</h3>
          <p className="text-sm text-gray-600 mb-4 leading-5">{getDescription()}</p>

          {mode !== "blocked" && (
            <>
              <label className="block text-sm font-medium mb-1 text-gray-700">
                Add Minutes:
              </label>

                  <input
                type="text"
                value={minutes}
                onChange={handleMinutesChange}
                placeholder="Enter value in minutes to extend"
                className="border px-3 py-2 w-full rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />

            </>
          )}

          <div className="flex justify-end mt-5 gap-2">
            <button
              onClick={onClose}
              className="px-3 py-1 bg-gray-300 rounded-md hover:bg-gray-400"
            >
              Close
            </button>

            {mode !== "blocked" && (
              <button
                onClick={submit}
                disabled={loading}
                className={`px-3 py-1 rounded-md text-white
                  ${loading ? "bg-blue-400" : "bg-blue-600 hover:bg-blue-700"}`}
              >
                {loading ? "Processing..." : "Extend"}
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ExtendTimePopup;
